import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Trans } from '@lingui/macro';
import ReactGa from 'react-ga';
import classNames from 'classnames';
import { useDisclosure } from '@chakra-ui/react';
import css from './footer-qtc.scss';
import { BtnText } from '../../components/buttons';
import {
  markActivity,
  resetConquest,
  setNextQuestion
} from '../conquest/conquest.actions';
import InfoFeedback from '../info-feedback/info-feedback';
import Info from '../info/info';
import { getValueFromUrl } from '../../helpers/utils';
import { enableSpinner, disableSpinner } from '../spinner/spinner-actions';
import { durationTypeCssClass, DURATION_TYPE_WHOLE, LEARNOSITY_SPINNER } from '../../helpers/constants';
import HandIn from './hand-in';

const FooterQtc = () => {
  const {
    isLoading,
    activityIndex,
    conquestIsReady,
    conquestUserAnswer,
    girlId
  } = useSelector(state => state.conquestReducer);
  const {
    questions,
    isCompleted,
    durationType
  } = useSelector(state => state.mleReducer || {});
  const dispatch = useDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleSaveAnswer = async () => {
    dispatch(enableSpinner(LEARNOSITY_SPINNER));
    await dispatch(markActivity({
      assignmentId: getValueFromUrl('assignmentId'),
      questionId: girlId,
      studentAnswer: conquestUserAnswer
    }));
    dispatch(setNextQuestion({
      currentIndex: activityIndex,
      totalQuestions: questions.length
    }));
    ReactGa.event({
      category: 'Button - Save answer',
      action: 'Mark the question',
      label: 'Student interaction'
    });
  };

  const handleChangeAnswer = async () => {
    dispatch(enableSpinner(LEARNOSITY_SPINNER));
    await dispatch(markActivity({
      assignmentId: getValueFromUrl('assignmentId'),
      questionId: girlId,
      studentAnswer: null
    }));
    dispatch(resetConquest());
    dispatch(disableSpinner(LEARNOSITY_SPINNER));
    ReactGa.event({
      category: 'Button - Change Answer',
      action: 'Change answer',
      label: 'Student interaction'
    });
  };

  const keyUpHandler = (event) => {
    if (conquestIsReady && event.key === 'Enter') {
      handleSaveAnswer();
    }
  };

  useEffect(() => {
    if (durationType === DURATION_TYPE_WHOLE) {
      window.addEventListener('keyup', keyUpHandler);
    }
    return () => {
      if (durationType === DURATION_TYPE_WHOLE) {
        window.removeEventListener('keyup', keyUpHandler);
      }
    };
  }, [conquestIsReady, conquestUserAnswer, isLoading]);

  return (
    <div className={classNames(css.footer, css[durationTypeCssClass[durationType]])}>
      <HandIn
        isOpen={isOpen}
        onClose={onClose}
      />
      <div className={css['activity-side']}>
        <div className={css['misc-container']}>
          <Info />
          <InfoFeedback
            className={css['info-feedback-margin']}
            girlId={girlId || ''}
          />
        </div>
        <div className={css['btn-cont']}>
          {
            questions.length > 0 && questions[activityIndex].isAttempted ?
              (
                <BtnText
                  className={css['btn-next']}
                  callBack={handleChangeAnswer}
                  isDisabled={isLoading || isCompleted}
                  type="secondary"
                >
                  <Trans>Change answer</Trans>
                </BtnText>
              ) : (
                <BtnText
                  className={css['btn-next']}
                  callBack={handleSaveAnswer}
                  isDisabled={!conquestIsReady || isCompleted}
                  type="secondary"
                >
                  <Trans>Next Question</Trans>
                </BtnText>
              )
          }
        </div>
      </div>
      <div className={css['progress-side']}>
        {
          durationType === DURATION_TYPE_WHOLE && (
            <BtnText
              className={css['btn-finish']}
              callBack={onOpen}
              isDisabled={isLoading || isCompleted}
            >
              <Trans>Finish & Submit</Trans>
            </BtnText>
          )
        }
      </div>
    </div>
  );
};

export default FooterQtc;

